var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
var AddGoodTable = (function (_super) {
    __extends(AddGoodTable, _super);
    function AddGoodTable() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AddGoodTable.prototype.selectionChange = function (rows, row) {
        this.$emit('selectChange', rows, row);
    };
    AddGoodTable.prototype.selectAll = function (rows) {
        this.$emit('selectChange', rows, null, true);
    };
    AddGoodTable.prototype.mounted = function () {
        console.log(11111, this.sorTable);
    };
    AddGoodTable.prototype.sortChange = function (_a) {
        var column = _a.column, prop = _a.prop, order = _a.order;
        if (!prop) {
            this.filter_order = null;
        }
        else {
            this.filter_order = [prop, order === 'ascending' ? 'asc' : 'desc'];
        }
        console.log(1111, column, this.filter_order);
        this.$emit('search', this.filter_order);
    };
    __decorate([
        Prop({
            required: true,
            type: Array
        })
    ], AddGoodTable.prototype, "data", void 0);
    __decorate([
        Prop({
            required: true,
            type: Number
        })
    ], AddGoodTable.prototype, "tableHeight", void 0);
    __decorate([
        Prop({
            required: true,
            type: Boolean
        })
    ], AddGoodTable.prototype, "sorTable", void 0);
    AddGoodTable = __decorate([
        Component
    ], AddGoodTable);
    return AddGoodTable;
}(Vue));
export default AddGoodTable;
